import React from 'react'
import { Col, Typography } from 'antd';
import GoogleMaps from '../GoogleMaps'

function OverviewTab(props: {property:any}) {
  const { property } = props;


  return (
    <Col>
      <Typography.Paragraph>{property &&               
      decodeURIComponent(property.Description).replace(/%0A/g, "\n").split('\n').map((line, index) => (
                <React.Fragment key={index}>
                  {line}
                  <br />
                </React.Fragment>
              ))}
      </Typography.Paragraph>
      {/* <GoogleMaps /> */}
    </Col>
  )
}

export default OverviewTab